import { fromJS, Map, List } from 'immutable';

const DOMAIN_NAME = '';
const NAME_SPACE = 'BASEINFO/';

const initialState = new Map({
  'loading': true,
  'pageSize': 0,
  'currentPage': 0,
  'count': 0,
  'data': new List([]),
  'shops': new List([]),
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_BASEINFO_COLLECTION':
      return state.merge(action.payload)
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', loading => action.payload.state);
    default:
      return state;
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_BASEINFO_COLLECTION':
      return item(state, action);
    case NAME_SPACE + 'V_LOADING':
      return item(state, action);
    default:
      return state;
  }
};
